// Generated by psc version 0.10.2
"use strict";
var Data_CommutativeRing = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/CommutativeRing.purs");
var Data_EuclideanRing = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/EuclideanRing.purs");
var Data_Ring = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Ring.purs");
var Data_Semiring = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Semiring.purs");
var Data_Unit = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Unit.purs");
var Field = function (__superclass_Data$dotEuclideanRing$dotEuclideanRing_0) {
    this["__superclass_Data.EuclideanRing.EuclideanRing_0"] = __superclass_Data$dotEuclideanRing$dotEuclideanRing_0;
};
var fieldUnit = new Field(function () {
    return Data_EuclideanRing.euclideanRingUnit;
});
var fieldNumber = new Field(function () {
    return Data_EuclideanRing.euclideanRingNumber;
});
module.exports = {
    Field: Field, 
    fieldNumber: fieldNumber, 
    fieldUnit: fieldUnit
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-prelude/src/Data/Field.purs
// module id = 60
// module chunks = 0